import { usersCollectionRef } from '../../firebase/collection/collectionReferences';

const fetchUserInfos = async (userId) => {
  const snapshot = await usersCollectionRef().doc(userId).get();

  return snapshot.data();
};

export default fetchUserInfos;
